import ScrollReveal from '@/components/ui/ScrollReveal'
import type { Metric } from '@/types'

interface ProjectMetricsProps {
  metrics: Metric[]
  sectionNumber?: string
}

export default function ProjectMetrics({ metrics, sectionNumber }: ProjectMetricsProps) {
  return (
    <ScrollReveal>
      <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-8 md:gap-12">
        <div>
          {sectionNumber && (
            <span className="text-label text-accent block mb-1">{sectionNumber}</span>
          )}
          <span className="text-label uppercase tracking-widest text-text-muted">Impact</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {metrics.map((metric) => (
            <div key={metric.label} className="flex flex-col gap-1">
              <span className="text-h2 text-accent font-semibold">{metric.value}</span>
              <span className="text-body-sm text-text-secondary">{metric.label}</span>
            </div>
          ))}
        </div>
      </div>
    </ScrollReveal>
  )
}
